module.exports = __webpack_public_path__ + "static/ux-378257e0e974ccfa4a1c06244a48bfe3.png";